"use client";

import { motion } from "motion/react";

// Solution gallery — a full-bleed grid where each image animates in as the
// page scrolls down, cycling three entrances: slide in left → right, slide in
// right → left, then fade + zoom in. Reduced-motion users get a simple fade.
type Img = { src: string; alt: string };

const EASE = [0.16, 1, 0.3, 1] as const;

// left → right, right → left, fade + zoom — repeating.
const ENTRANCES = [
  { x: -90, y: 0, scale: 1 },
  { x: 90, y: 0, scale: 1 },
  { x: 0, y: 0, scale: 0.82 },
];

function Tile({ g, i }: { g: Img; i: number }) {
  const from = ENTRANCES[i % ENTRANCES.length];
  return (
    <motion.div
      initial={{ opacity: 0, ...from }}
      whileInView={{ opacity: 1, x: 0, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 0.75, ease: EASE, delay: (i % 3) * 0.1 }}
      className="group aspect-[4/3] overflow-hidden"
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={g.src}
        alt={g.alt}
        loading="lazy"
        decoding="async"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05] [filter:contrast(1.03)_saturate(1.04)]"
      />
    </motion.div>
  );
}

export function SolutionGallery({ images }: { images: Img[] }) {
  if (!images || images.length === 0) return null;
  return (
    <div className="grid grid-cols-2 gap-3 px-4 sm:grid-cols-3 md:gap-4 lg:px-0">
      {images.map((g, i) => (
        <Tile key={g.src} g={g} i={i} />
      ))}
    </div>
  );
}
